<template>
  <Card title="考核记录">
    <a-form-model layout="inline" @keyup.enter.native="query" style="margin-bottom: 2vh">
      <a-form-model-item>
          <InputField labelWidth="0"  type="text" id="location" v-model="form.name"  placeholder="姓名"/>
      </a-form-model-item>

      <a-form-model-item>
          <RangePickerField labelWidth="0" v-model="form.date1" :placeholder="['考核开始日期', '考核结束日期']" :disabled="false"/>
      </a-form-model-item>

      <a-form-model-item>
        <a-space>
            <ButtonField text="查询" @click="query" secondary />
            <ButtonField text="重置" primary @click="reset"/>
        </a-space>
      </a-form-model-item>
    </a-form-model>
      <Tablelist
              style="margin-top: 1rem"
              :showCheckbox="false"
              :list="list"
              :columns="tableColumns"
     />

  </Card>
</template>
  
<script>
import { fetchList } from "../api/log";

export default {
  data() {
    return {
      form: {},
      loading: false,
      current: 1,
      pageSize: 10,
      list: [
          {id: 1,userName: "张三",timeBegin: "2025-07-01",timeEnd: "2025-07-31",taskNumPlan: 10,taskNumDone: 8,finishingRate: 0.8,appraisal: "优秀"},
          {id: 2,userName: "李四",timeBegin: "2025-08-01",timeEnd: "2025-08-31",taskNumPlan: 12,taskNumDone: 10,finishingRate: 0.83,appraisal: "良好"},
          {id: 3,userName: "王五",timeBegin: "2025-09-01",timeEnd: "2025-09-30",taskNumPlan: 8,taskNumDone: 6,finishingRate: 0.75,appraisal: "合格"}
      ],
      total: 0,
      tableColumns: [
          {
              key: 'userName',
              title: '姓名',
              field: 'userName',
              infotype: 'text'
          },
          {
              key: 'timeBegin',
              title: '考核开始日期',
              field: 'timeBegin',
              infotype: 'text',
          },
          {
              key: 'timeEnd',
              title: '考核结束日期',
              field: 'timeEnd',
              infotype: 'text',
          },
          {
              key: 'taskNumPlan',
              title: '指派任务数量',
              field: 'taskNumPlan',
              infotype: 'text',
          },
          {
              key: 'taskNumDone',
              title: '实际完成数量',
              field: 'taskNumDone',
              infotype: 'text',
          },
          {
              key: 'finishingRate',
              title: '任务完成率',
              field: 'finishingRate',
              infotype: 'text',
              render: (item) => {
                  return `${item.finishingRate * 100}%`;
              }
          },
          {
              key: 'taskNumPlan',
              title: '指派任务数量',
              field: 'taskNumPlan',
              infotype: 'text',
          },
          {
              key: 'appraisal',
              title: '评价',
              field: 'appraisal',
              infotype: 'text',
          },
      ],
    };
  },

  mounted() {
    this.getList();
  },

  methods: {
    getList() {
      this.loading = true;
      const { current, pageSize } = this;

      let timeBeginGt, timeBeginLt, timeEndGt, timeEndLt;

      if (Array.isArray(this.form.date1) && this.form.date1.length === 2) {
        timeBeginGt = this.form.date1[0].format("YYYY-MM");
        timeBeginLt = this.form.date1[1].format("YYYY-MM");
      }
      if (Array.isArray(this.form.date2) && this.form.date2.length === 2) {
        timeEndGt = this.form.date2[0].format("YYYY-MM");
        timeEndLt = this.form.date2[1].format("YYYY-MM");
      }

      fetchList({
        pageNum: current,
        pageSize: pageSize,

        name: this.form.name,
        timeBeginGt,
        timeBeginLt,
        timeEndGt,
        timeEndLt,
      })
        .then((res) => {
          if (Array.isArray(res.list)) {
            this.list = Object.freeze(res.list);
            this.total = res.totalSize || 0;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onChange(pagination) {
      this.current = pagination.current;
      this.getList();
    },

    query() {
      this.current = 1;
      this.getList();
    },
    reset() {
      this.form = {};
      this.current = 1;
      this.getList();
    },
  },
};
</script>